import React, { useState } from "react";
import { useForm } from "react-hook-form";
import logo from "../img/exam_logo.png";
// import logo from "../img/logo.png";
import "../css/home.css";
import axios from "axios";
import { Spin } from "antd";
import { notification } from "antd";
import "react-toastify/dist/ReactToastify.css";
import Login from "./Login";

function Home() {
  const { register, handleSubmit, setValue } = useForm();
  const [login, setLogin] = useState(true)
  const [info, setInfo] = useState({});
  const [showInfo, setShowInfo] = useState(false);
  const [loading, setLoading] = useState(false);
  const [isForeignPerson, setIsForeignPerson] = useState(false);
  const [result, setResult] = useState("");

  // const examURL = "https://backimes.culture.az/api/exam-infos";
  // const resultUrl = "https://backimes.culture.az/api/teacher-exam-results";
  const resultUrl = "https://backimes.culture.az/api/v2/exam-results";

  const handleCheckboxChange = () => {
    setIsForeignPerson(!isForeignPerson);
    if (!isForeignPerson) {
      setValue("seriyaNo", "MYİ");
    } else {
      setValue("seriyaNo", "AA");
    }
  };

  const onSubmit = (data) => {
    const seriyaCombined = data.seriyaNo.toUpperCase() + data.seriyaValue;
    const params = {
      pin: data.fin,
      serial: seriyaCombined
    };
    setLoading(true);

    axios
      .get(resultUrl, { params })
      .then((response) => {
        setShowInfo(true);
        // setInfo(response.data.data.info);
        setResult(response.data.data.info);
      })
      .catch((error) => {
        const message = error.response.data.data.message || 'Xəta baş verdi'
        notification.error({
          description: message,
          placement: "topRight",
        });
      })
      .finally(() => setLoading(false));
  };

  const titles = [
    { key: "student_name", label: "Ad" },
    { key: "student_surname", label: "Soyad" },
    { key: "speciality", label: "İxtisas" },
    { key: "exam_date", label: "İmtahan tarixi" },
    { key: "exam_place", label: "İmtahan yeri" },
    { key: "exam_address", label: "İmtahan ünvanı" },
  ];

  return (
    <>
      {login ? <div className="form-page">
        <div className="header">
          <img src={logo} alt="Logo" className="logo" />
          {/* <h1 className="exam-title">
          İmtahan tarixini və keçiriləcəyi yeri öyrən
        </h1> */}
          <h1 className="exam-title">Uşaq musiqi, incəsənət məktəb və mərkəzlərinə təhsilalanların qəbulu ilə bağlı keçirilmiş imtahanın nəticələri</h1>
        </div>
        <div className="form">
          <form onSubmit={handleSubmit(onSubmit)} className="form-container">
            <h2 className="title">Namizəd məlumatları</h2>
            <div className="form-group">
              <label htmlFor="finKod">Fin kod</label>
              <input id="finKod" {...register("fin")} className="fin" />
            </div>

            <div className="form-group">
              <label htmlFor="seriyaNo">Seriya №</label>
              <div className="seriya-container">
                <select id="seriyaNo" {...register("seriyaNo")}>
                  {!isForeignPerson && (
                    <>
                      <option value="AA">AA</option>
                      <option value="AZE">AZE</option>
                      <option value="AB">AB</option>
                      <option value="AC">AC</option>
                    </>
                  )}
                  {isForeignPerson && (
                    <>
                      <option value="MYİ">MYİ</option>
                      <option value="DYİ">DYİ</option>
                    </>
                  )}
                </select>
                <input id="seriyaValue" {...register("seriyaValue")} />
              </div>
            </div>
            <div className="form-group">
              <label className="foreign">
                <input
                  type="checkbox"
                  checked={isForeignPerson}
                  onChange={handleCheckboxChange}
                />
                Xarici vətəndaş
              </label>
            </div>

            <div className="btn">
              <button type="submit">Axtar</button>
            </div>
          </form>
        </div>
        {loading && (
          <div className="loading-spinner">
            <Spin spinning={loading} size="large" />
          </div>
        )}
        {showInfo && (
          <div className="result">
            <div className="result-container">
              <h2 className="title">Axtarış nəticəsi</h2>
              <div className="">
                {/* {titles.map(({ key, label }) => (
                <div className="result-info" key={key}>
                  <p>{label}</p>
                  <p className="content">{info[key]}</p>
                </div>
              ))} */}
                <div className="result-info">
                  <p dangerouslySetInnerHTML={{ __html: result }}></p>
                </div>
              </div>
            </div>
          </div>
        )}
      </div> :
        <Login setLogin={setLogin} />
      }
    </>
  );
}

export default Home;
